<div class="wrapper overflow-y-auto">
    <div class="row top-card justify-content-between">
        <div class="top-left-container">
            <div class="">
                <div class="labels">Select Date Range <span style="color: red;">*</span></div>
                <div class="">
                    <mat-form-field
                        class="custom_select_checkbox_chips custom_date_picker"
                        appearance="outline"
                    >
                        <mat-date-range-input
                            [max]="maxDate"
                            [formGroup]="range"
                            [rangePicker]="picker"
                        >
                            <input
                                matStartDate
                                formControlName="start"
                                [(ngModel)]="start_date"
                                placeholder="Start date"
                            >
                            <input
                                matEndDate
                                formControlName="end"
                                [(ngModel)]="end_date"
                                placeholder="End date"
                            >
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker>
                            <mat-date-range-picker-actions>
                                <button mat-button matDateRangePickerCancel>
                                    Cancel
                                </button>
                                <button
                                    mat-raised-button
                                    color="primary"
                                    matDateRangePickerApply
                                    (click)="updateTimesheetData()"
                                >Apply</button>
                            </mat-date-range-picker-actions>
                        </mat-date-range-picker>

                        <mat-error
                            *ngIf="range.controls.start.hasError('matStartDateInvalid')"
                        >Invalid start date</mat-error>
                        <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">
                            Invalid end date
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row details">
                <div class="col mt-3">
                    <div class="row">
                        <div class="projectCounts">
                            <div class="row" style="height: 100%;">
                                <div class="rightLine"></div>
                                <div class="col widgetdata">
                                    <div class="counts">{{ totalProjectCount }}</div>
                                    <div class="labels">Total Projects</div>
                                    <div class="label_icon">
                                        <span
                                            class="material-symbols-outlined filter-icon"
                                            (click)="filterWithWidgetIcons('All')"
                                        >
                                            filter_alt
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="projectCounts" style="margin-left: 24px;">
                            <div class="row" style="height: 100%;">
                                <div class="rightLine"></div>
                                <div class="col widgetdata">
                                    <div class="counts">{{differProjectCount}}</div>
                                    <div class="labels">Project with differs</div>
                                    <div class="label_icon">
                                        <span
                                            class="material-symbols-outlined filter-icon"
                                            (click)="filterWithWidgetIcons('mismatch')"
                                        >
                                            filter_alt
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>  
                        <!-- <div class="timesheetpiechart">
                        <p-chart  #chart5 type="pie" [data]="pieChartData" [options]="pieChartOptions"
                            [height]="280">
                        </p-chart>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="top-right-container row m-0">
            <form [formGroup]="timeSheetForm" class="inline-form-custom">
                <div class="last-updated">
                    <label for="lastUpdated">PeopleStrong(PS) updated date: </label>
                    <span id="lastUpdated">{{lastUpdatedDate}}</span>
                </div>
                <div class="buttons">
                    <span
                        style="margin-top: 10px; margin-right: 10px; cursor: pointer;"
                        class="material-symbols-outlined"
                        (click)="getFileHistory()"
                        title="Refresh"
                    >
                        sync
                    </span>
                    <button
                        [ngClass]="{'request-timesheet-button': !isRequestCompleted, 'request-timesheet-green-button': isRequestLoading}"
                        class="request-timesheet-button"
                        (click)="requestTimesheet()"
                        [disabled]="isRequestCompleted"
                    >Request PeopleStrong Data</button>
                    <button
                        class="compare-timesheet-button"
                        (click)="reloadPage()"
                        [disabled]="!isRequestCompleted"
                    >Compare Timesheet Data</button>
                </div>
            </form>
            <div *ngIf="!fileHistoryList.length" class="file-history-empty">
                <span class="empty-table-text">Request Timesheets and upload Excel file in the provided OneDrive Folder</span>
            </div>
            <div *ngIf="fileHistoryList.length > 0" class="file-history-table">
                <mat-table [dataSource]="fileHistoryList" matSort class="fixed-table">
                    <!-- <ng-container matColumnDef="fileName">
                      <mat-header-cell *matHeaderCellDef mat-sort-header> File Name </mat-header-cell>
                      <mat-cell *matCellDef="let row"> {{ row.fileName }} </mat-cell>
                    </ng-container> -->
              
                    <ng-container matColumnDef="createdOn">
                      <mat-header-cell *matHeaderCellDef mat-sort-header> Created On </mat-header-cell>
                      <mat-cell *matCellDef="let row"> {{ row.createdOn | date: 'dd-MM-yyyy'}}</mat-cell>
                    </ng-container>
              
                    <ng-container matColumnDef="lastUpdatedOn">
                      <mat-header-cell *matHeaderCellDef mat-sort-header> Last Updated On </mat-header-cell>
                      <mat-cell *matCellDef="let row"> {{ row.lastUpdatedOn | date: 'dd-MM-yyyy' }} </mat-cell>
                    </ng-container>
              
                    <ng-container matColumnDef="statusNote">
                      <mat-header-cell *matHeaderCellDef mat-sort-header> Status Note </mat-header-cell>
                      <mat-cell *matCellDef="let row"> {{ row.statusNote }} </mat-cell>
                    </ng-container>
              
                    <mat-header-row *matHeaderRowDef="fileHistoryColumns; sticky: true"></mat-header-row>
                    <mat-row
                      [class.odd]="i % 2 == 1"
                      [class.even]="i % 2 == 0"
                      *matRowDef="let row; columns: fileHistoryColumns; let i = index;"
                    >
                    </mat-row>
                  </mat-table>
            </div>
        </div>
    </div>
    <div class="bottom-card">
        <div class="button-group">
            <button
                class="d-flex justify-content-end"
                style="border: none;background: none; cursor: pointer;"
                (click)="openLineChartDialog()"
            >
                <mat-icon>error</mat-icon>
            </button>
            <button
                style="width: 107px;"
                class="custom_btn primary_btn_base d-flex align-items-center add_proposal_btn export_button"
                (click)="filterWithWidgetIcons('All')"
            >View All</button>
            <div class="">
            </div>

            <button
                class="custom_btn primary_btn_base d-flex align-items-center add_proposal_btn export_button"
                (click)="exportData()"
            >Export</button>
        </div>
        <div class="table" class="mt-2 custom_table" *ngIf="attendanceTableHeader.length > 0">
            <table>
                <thead>
                    <tr>
                        <th
                            class="text-center"
                            *ngFor="let head of attendanceTableHeader;let i=index"
                            [attr.rowspan]="head.Children ? 1 : 2"
                            [attr.colspan]="head.Children ? head.Children.length : 0"
                        >
                            <div
                                class="header-row"
                                [ngStyle]="{'justify-content': head.Children ? 'center' : 'space-between' }"
                            >
                                <div class="">{{head.Name}}</div>
                                <div class="" *ngIf="head.FilterStatus">
                                    <span
                                        *ngIf="isFilterActive(head.Name)"
                                        style="font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;"
                                        class="material-symbols-sharp filter-icon"
                                        (click)="filterBlock(head.Name)"
                                    >
                                        filter_alt
                                    </span>
                                    <span
                                        *ngIf="!isFilterActive(head.Name)"
                                        class="material-symbols-outlined filter-icon"
                                        (click)="filterBlock(head.Name)"
                                    >
                                        filter_alt
                                    </span>
                                </div>
                                <div
                                    *ngIf="isFilterOpen(head.Name)"
                                    class="filter-container"
                                    tabindex="1"
                                >
                                    <div>
                                        <span
                                            class="material-symbols-outlined clearIcon"
                                            (click)="closeFilterPanel(head.Name)"
                                        >
                                            close
                                        </span>
                                    </div>
                                    <input
                                        #input
                                        type="text"
                                        mat-input
                                        class="form-control search-Text"
                                        (input)="searchOptions(input.value,head.Name)"
                                        placeholder="Search {{head.Name}}"
                                    />
                                    <div>
                                        <button
                                            mat-raised-button
                                            class="filterCancelBtn"
                                            (click)="clearFilter(head.Name,head.PropKey)"
                                        >Clear</button>
                                        <button
                                            mat-raised-button
                                            class="filterApplyBtn"
                                            color="primary"
                                            (click)="applyFilter(head.Name,head.PropKey)"
                                        >Apply</button>
                                    </div>
                                    <div class="filterOptionsBlock">
                                        <!-- <div class="filterOptions">
                                            <mat-checkbox
                                                class="custom_mdc_checkbox"
                                                [checked]="checkSelectAll(head.Name)"
                                                (change)="toggleSelectAll($event,head.Name)"
                                            >Select All</mat-checkbox>
                                        </div> -->
                                        <div
                                            class="filterOptions"
                                            *ngFor="let option of ListOfFilterOptions"
                                        >
                                            <mat-checkbox
                                                class="custom_mdc_checkbox"
                                                [(ngModel)]="option.isSelected"
                                                [checked]="option.isSelected"
                                                (change)="changeSelect($event,head.Name)"
                                            >{{option.optionValue}}</mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </th>
 
                    </tr>
                    <tr>
                        <th class="text-center childRow" *ngFor="let head of getChildrenOnlyHeader()">
                            {{head.Label}}
                        </th>
                    </tr>
                </thead>
 
                <tbody *ngIf="ListOfEmpAttendance.length > 0">
                    <tr
                        *ngFor="let att of ListOfEmpAttendance"
                        [ngClass]="{'invalid':att.IsValid==false}"
                    >
                        <td
                            *ngIf="att.DeliveryManager!==undefined  && att.deliveryManagerColumnSpan"
                            [attr.rowspan]="att.deliveryManagerColumnSpan"
                            class="fixed-width"
                        >
                            {{att?.DeliveryManager}}
                        </td>
                        <td
                            *ngIf="att.ProjectName!==undefined && att.projectNameColumnSpan"
                            [attr.rowspan]="att.projectNameColumnSpan"
                            class="fixed-width"
                        >
                            {{att?.ProjectName}}
                        </td>
                        <!-- <td *ngIf="att.CustomerName!==undefined">
                            {{att?.CustomerName}}
                        </td>
                        <td *ngIf="att.PortfolioLeader!==undefined"  >
                            {{att?.PortfolioLeader}}
                        </td>
                       
                        <td *ngIf="att.EngineeringManager!==undefined">
                            {{att?.EngineeringManager}}
                        </td>
                        <td *ngIf="att.ClientPartner!==undefined">
                            {{att?.ClientPartner}}
                        </td>
                        <td *ngIf="att.EmpId!==undefined" [ngClass]="att.IsValid ? 'valid' : 'inValid'">
                            {{att.EmpId}}
                        </td> -->
                        <td
                            *ngIf="att.Name!==undefined"
                            [ngClass]="att.IsValid ? 'valid' : 'inValid'"
                            class="fixed-width"
                        >
                            <div class="d-flex justify-content-between align-items-center">
                                <div style="width: 75%;">
                                    <span>{{ att?.Name }}</span>
                                </div>
                                <div class="mismatch-actions">
                                    <a
                                        *ngIf="att.IsValid==false"
                                        (click)="openComment(att)"
                                    >
                                        <i class="fa fa-envelope" aria-hidden="true"></i>
                                    </a>
                                    <span
                                        *ngIf="att.IsValid==false"
                                        (click)="openManagerCommentsPopup(att)"
                                        class="material-symbols-outlined manager-comments-icon"
                                    > chat
                                    </span>
                                </div>
                            </div>
                        </td>
                        <td class="text-center fixed-width" *ngFor="let head of att.mappedChildrenData">
                            <i
                                [matTooltip]="head.StatusText"
                                class="fa fa-check-circle match"
                                *ngIf="head.Status == 'match'"
                            ></i>
                            <ng-container *ngIf="head.Status == 'mismatch'">
                                <div class="mismatch-top">
                                        <mat-checkbox
                                            class="custom_mdc_checkbox"
                                            [checked]="head.isSelected"
                                            (change)="toggleCheckbox(head)"
                                        ></mat-checkbox>
                                        <i
                                            class="fa fa-exclamation-circle notpresent"
                                            data-toggle="modal"
                                            data-target="#exampleModal"
                                        ></i>
                                </div>
                                <div
                                    class="mismatch-bottom"
                                    *ngIf="head.isSelected"
                                    [innerHTML]="head.StatusText"
                                >
                                </div>
                            </ng-container>
                            <i
                                [matTooltip]="head.StatusText"
                                class="fa fa-times-circle notpresent"
                                *ngIf="head.Status == 'not_present_in_ps'"
                            ></i>
                            <i
                                [matTooltip]="head.StatusText"
                                class="fa fa-times-circle present"
                                *ngIf="head.Status == 'present_in_ps'"
                            ></i>
                            <i
                                [matTooltip]="head.StatusText"
                                class="fas fa-calendar-check"
                                *ngIf="head.Status == 'Weekly Off'"
                            ></i>
                            <i
                                [matTooltip]="head.StatusText"
                                class="material-icons-outlined"
                                *ngIf="head.Status == 'Paternity Leave'"
                            >family_restroom</i>
                            <i
                                [matTooltip]="head.StatusText"
                                class="material-icons-outlined"
                                *ngIf="head.Status == 'Maternity Leave'"
                            >pregnant_woman</i>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="ListOfEmpAttendance.length <=0" class="no-records">
                No records
            </div>
        </div>
    </div>

    <!-- <div class="card mt-3 pb-3">
        <form [formGroup]="timeSheetForm" class="inline-form-custom">
            <div class="row m-0">
               
                <div class="col-md-8 pl-0" *ngIf="timesheetAdmin">
                    <div class="row m-0">
                        <div class="col-6 pl-0">
                            <div class="labels">Project Manager :</div>
                            <div class="">
                                <mat-form-field class="custom_select_checkbox_chips" appearance="outline">
                                    <input type="text" #inputTrigger placeholder="Select items" matInput
                                        [matAutocomplete]="autoComplete" [formControl]="searchTermControlManager"
                                        [matChipInputFor]="chipList" placeholder="Select Project Manager" />
                                </mat-form-field>
                                <mat-autocomplete class="custom_mdc_checkbox" #autoComplete="matAutocomplete">
                                    <mat-option *ngIf="storeProjectManagerNames.length > 0">
                                        <mat-checkbox [checked]="isAllManagerSelected"
                                            (change)="toggleSelectAllManagers()" (click)="$event.stopPropagation()">
                                            Select All
                                        </mat-checkbox>
                                    </mat-option>
                                    <mat-option *ngFor="let item of storeProjectManagerNames" [value]="item">
                                        <div (click)="optionClicked($event, item);">
                                            <mat-checkbox [checked]="item.selected"
                                                (change)="toggleSelectionManager(item)"
                                                (click)="$event.stopPropagation()">
                                                {{item.name}} ({{item.employeeId}})
                                            </mat-checkbox>
                                        </div>
                                    </mat-option>
                                </mat-autocomplete>
                            </div>
                        </div>
                        <div class="col-6">
                            <div *ngIf="selectedManagers.length > 0">
                                <div class="form-control field_value custom_Scrollbar custom_chip_box"> <mat-chip-list
                                        class="custom_chip_grid" [disabled]="true">
                                        <ng-container *ngFor="let manager of selectedManagers; let i = index">
                                            <mat-chip [removable]="true" (removed)="removeManager(manager)">
                                                {{ manager.name }} ({{ manager.employeeId }})
                                                <mat-icon matChipRemove class="pl-1 pr-2">cancel</mat-icon>
                                            </mat-chip>
                                        </ng-container>
                                    </mat-chip-list>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-1" style="align-self: center;">
                    <button *ngIf="timesheetAdmin" [disabled]="selectedManagers.length <= 0"
                        [ngClass]="selectedManagers.length > 0 ? 'primary_btn_base' : 'disable_btn'"
                        class=" custom_btn " (click)="submitButton()">
                        <span>Submit</span>
                    </button>
                </div>
            </div>
        </form>
        <div>
        </div>
        <div class="row viewbutton">
        </div>
        <div class="mt-2 custom_table" *ngIf="attendanceTableHeader.length > 0">
            
 
        </div>
 
    </div> -->
 
</div>
<ng-template let-data #myInfoDialog>
    <h1 mat-dialog-title class="popup-title w-100">
        Comments
    </h1>
    <div mat-dialog-content class="popup-content">
        <div style="color: black;font-size: large;"> <span style="font-weight: bold;"> Employee Name :</span>
            {{data.employeeName}}</div>
        <div style="color: black;font-size: large;"> <span style="font-weight: bold;">Email :</span>{{data.Email}}
        </div>
        <div style="color: black;font-size: large;"> <span style="font-weight: bold;">Manager Name :</span>
            {{data.managerName}}</div>
        <div style="color: black;font-size: large;"> <span style="font-weight: bold;">Project Name :
            </span>{{data.projectName}}</div>
 
        <textarea id="comments" rows="2" cols="50" class="form-control mt-4" [(ngModel)]="commentToMail"
            placeholder=" Your Comments"></textarea>
    </div>
    <div mat-dialog-actions class="popup-buttons d-flex justify-content-end">
        <button [mat-dialog-close]="true" class=" popup-okbutton btn">
            Submit
        </button>
        <button mat-dialog-close class=" popup-cancelbutton btn ml-2">
            Close
        </button>
    </div>
</ng-template>

<ng-template let-data #CommentsDialog>
    <h1 mat-dialog-title class="popup-title w-100">
        Manager Comments for Multiple Projects
    </h1>
    <div mat-dialog-content class="popup-content">
        <textarea
            id="comments"
            rows="2"
            cols="50"
            class="form-control mt-4"
            [(ngModel)]="dialogManagerComment"
            placeholder=" Your Comments"
        ></textarea>
    </div>
    <div mat-dialog-actions class="popup-buttons d-flex justify-content-end">
        <button
            [class.disabled]="!dialogManagerComment || dialogManagerComment === initialDialogComment"
            [disabled]="!dialogManagerComment || dialogManagerComment === initialDialogComment"
            [mat-dialog-close]="dialogManagerComment"
            class="popup-okbutton btn"
        >
            Submit
        </button>
        <button mat-dialog-close class="popup-cancelbutton btn ml-2">
            Close
        </button>
    </div>
</ng-template>
<!-- <div class="modal fade pr-0" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog m-0 ml-auto" role="document">
        <div class=" modal-content ">
            <div class="modal-header">
                <button type="button" class="close m-0 p-0" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" class="cancel">&times;</span>
                </button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div>
                    <h2 class="advance">Differ Dates</h2>
                </div>
 
            </div>
            <div class="modal-body">
                <div class="sidebar">
                </div>
            </div>
 
        </div>
    </div>
</div> -->
 